import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import useMediaLink from '@hooks/useMediaLink'
import useMediaLinks from '@hooks/useMediaLinks'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import MediaLink from '@components/MediaLinkListItem'

import { UserModel } from '@domain-group/realhub-backend-api-types'

type ExternalLinksProps = {
  user: UserModel,
}

const ExternalLinks = (props: ExternalLinksProps) => {
  const {
    user,
  } = props

  const { filteredMediaLinks } = useMediaLinks(
    {
      filters: { linkable_type: 'User', linkable_id: user.id },
      performHttpRequests: !!user.id,
      requestOptions: {},
    },
  )

  const initMediaLink = {
    linkable_id: user.id,
    linkable_type: 'User',
  }

  const {
    callbacks: { createOrEditMediaLink },
  } = useMediaLink(initMediaLink)

  return (
    <DashboardModule title="External Links" boxProps={{ marginBottom: 'large' }}>
      <Box flexDirection="column">
        <Box flexDirection="column">
          {filteredMediaLinks.map(link => <MediaLink key={link.id} mediaLink={link} />)}
        </Box>

        <Box
          borderTop={filteredMediaLinks.length ? '1px dashed' : 'none'}
          borderTopColor="lineColor"
        >
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={createOrEditMediaLink}
            size="medium"
            style={{ margin: 16, width: 'calc(100% - 32px)' }}
          >
            Add Link
          </Button>
        </Box>
      </Box>
    </DashboardModule>
  )
}

export default ExternalLinks
